import { Button, Modal } from 'antd';

import owlImg from '../../../../assets/img/pet/corujaFeliz.png';

import { ContainerFooter, Content, ModalContainer } from './styles';

interface UserProps {
  id: number;
  name: string;
  sobrenome: string;
  foto: string;
}

interface SuccessInviteModalProps {
  isOpen: boolean;
  user: UserProps;
  closeModal: () => void;
}

export const SuccessInviteModal = ({
  closeModal,
  isOpen,
  user,
}: SuccessInviteModalProps) => {
  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <ContainerFooter key="footer">
            <Button type="primary" onClick={closeModal} key="closeModal">
              Fechar
            </Button>
          </ContainerFooter>,
        ]}
      >
        <Content>
          <h1>Sucesso!</h1>

          <img src={owlImg} alt="Imagem de uma coruja" />

          <span>
            <p>
              <strong>
                {user.sobrenome ? `${user.name} ${user.sobrenome}` : user.name}{' '}
              </strong>
              foi convidado(a) para sua liga.
            </p>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
